import { motion } from "framer-motion";
import { Share2, Search, FileText, Factory, Truck } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import SectionHeading from "@/components/SectionHeading";

export default function ProcessSection() {
  const { t } = useLanguage();

  const steps: { icon: LucideIcon; number: string; titleKey: string; descKey: string }[] = [
    { icon: Share2, number: "01", titleKey: "step1Title", descKey: "step1Desc" },
    { icon: Search, number: "02", titleKey: "step2Title", descKey: "step2Desc" },
    { icon: FileText, number: "03", titleKey: "step3Title", descKey: "step3Desc" },
    { icon: Factory, number: "04", titleKey: "step4Title", descKey: "step4Desc" },
    { icon: Truck, number: "05", titleKey: "step5Title", descKey: "step5Desc" },
  ];

  return (
    <section className="bg-steel-light section-padding px-4 sm:px-6 lg:px-8">
      <div className="content-container">
        <SectionHeading overlineKey="howWeWork" titleKey="fromInquiryToDelivery" align="center" />

        <div className="mt-12 relative">
          <div className="hidden lg:block absolute top-14 left-[10%] right-[10%] h-0.5 bg-silver">
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.2, ease: [0.25, 0.46, 0.45, 0.94] }}
              className="h-full bg-secondary-blue origin-left"
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-6">
            {steps.map((step, i) => {
              const Icon = step.icon;
              return (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.12, ease: [0.25, 0.46, 0.45, 0.94] }}
                  className="relative flex flex-col items-center text-center"
                >
                  <div className="w-20 h-20 rounded-2xl bg-primary-deep flex items-center justify-center mb-5 relative z-10 ring-4 ring-steel-light shadow-lg">
                    <Icon className="w-8 h-8 text-white" />
                    <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-gold flex items-center justify-center text-white text-xs font-bold">
                      {step.number}
                    </span>
                  </div>
                  <h3 className="font-display font-bold text-base text-graphite mb-1">{t(step.titleKey)}</h3>
                  <p className="text-sm text-steel max-w-[200px]">{t(step.descKey)}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
